import React from 'react';
import { BookOpen, Scale, Lightbulb, ClipboardCheck, Calendar } from 'lucide-react';
export function QueIncluye() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const blocks = [{
    title: 'Fundamentos de la Filosofía',
    icon: <BookOpen className="text-blue-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-148" />,
    color: 'blue',
    items: ['Introducción al pensamiento filosófico', 'Mito y logos', 'Conocimiento y verdad', 'La Alegoría de la Caverna', 'Pensamiento crítico y problematización', 'Actividades de análisis y debate']
  }, {
    title: 'Historia y problemas filosóficos',
    icon: <Scale className="text-purple-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-149" />,
    color: 'purple',
    items: ['Ética y moral', 'Filosofía política', 'Modernidad y sujeto', 'Alienación e ideología', 'Filosofía contemporánea', 'Estudios de caso y análisis aplicado']
  }, {
    title: 'Recursos didácticos para el aula',
    icon: <Lightbulb className="text-green-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-150" />,
    color: 'green',
    items: ['Secuencias listas para aplicar', 'Actividades prácticas y participativas', 'Propuestas lúdicas', 'Textos adaptados para secundaria', 'Banco ampliado de consignas', 'Dinámicas de debate']
  }, {
    title: 'Evaluaciones y organización',
    icon: <ClipboardCheck className="text-orange-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-151" />,
    color: 'orange',
    items: ['Modelos de evaluaciones', 'Recuperaciones estratégicas', 'Consignas argumentativas', 'Criterios claros de corrección', 'Actividades integradoras']
  }, {
    title: 'Planificación anual',
    icon: <Calendar className="text-cyan-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-152" />,
    color: 'cyan',
    items: ['Fundamentación pedagógica', 'Organización por ejes centrales', 'Distribución por periodos (trimestres o bimestres)', 'Criterios de evaluación', 'Material adaptable a distintos planes curriculares']
  }];
  const getColorClasses = (color: string) => {
    const colors: Record<string, string> = {
      blue: 'bg-blue-100 group-hover:bg-blue-200',
      purple: 'bg-purple-100 group-hover:bg-purple-200',
      green: 'bg-green-100 group-hover:bg-green-200',
      orange: 'bg-orange-100 group-hover:bg-orange-200',
      cyan: 'bg-cyan-100 group-hover:bg-cyan-200'
    };
    return colors[color] || 'bg-gray-100';
  };
  return <section id="que-incluye" className="py-5 sm:py-14 bg-white relative overflow-hidden" data-id="element-153">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-154">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-155"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-156"></div>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-157">
        <div className="text-center mb-4 sm:mb-10" data-id="element-158">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-159">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-160">Kit Completo Filosofía Lista</span>
            ?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto" data-id="element-161">
            Este mega combo reúne material de filosofía educativa en un solo
            lugar, con recursos prácticos, actuales y pensados para aplicar
            directamente en el aula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-4 mb-4 sm:mb-10" data-id="element-162">
          {blocks.map((block, index) => <div key={index} onClick={scrollToOffer} className={`bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group cursor-pointer ${index === 4 ? 'md:col-span-2 lg:w-2/3 lg:mx-auto' : ''}`} data-id="element-163">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-164">
                <div className={`${getColorClasses(block.color)} w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors`} data-id="element-165">
                  {block.icon}
                </div>
                <div data-id="element-166">
                  <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3" data-id="element-167">
                    {block.title}
                  </h3>
                  <ul className="space-y-1 sm:space-y-1.5" data-id="element-168">
                    {block.items.map((item, i) => <li key={i} className="text-gray-600 text-xs sm:text-sm flex items-start" data-id="element-169">
                        <span className="mr-1.5 text-[#f59e0b]" data-id="element-170">•</span>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}